import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

export function fetchPlans(offset, length, companyIDToken) {
  return fetchWithCSRFToken(`/small-group/select-plan/ajax-quote-plans?company_id_token=${companyIDToken}&offset=${offset}&length=${length}`, {});
}
export function fetchPricing(employeeProfile, visiblePlanIDs, companyIdToken) {
  const url = `/small-group/select-plan/ajax-quote-pricing?company_id_token=${companyIdToken}`;
  const body = {
    visible_plan_ids: JSON.stringify(visiblePlanIDs),
    employee_profile: JSON.stringify(employeeProfile),
  };
  const payload = {
    method: "POST",
    body: JSON.stringify(body),
    processData: false,
  };
  return fetchWithCSRFToken(url, payload);
}
